// extracted by mini-css-extract-plugin
module.exports = {"grid":"knowledgebase-post-grid-module--grid--26qUd","fullWidth":"knowledgebase-post-grid-module--full-width--sYTaS","shake":"knowledgebase-post-grid-module--shake--39JUI"};